var React = require('react');

function BackToTop (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"7.96","y1":"1.87","x2":"7.96","y2":"14.06","style":{"fill":"none","stroke":"#b2b2b2","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":0}),React.createElement("polyline",{"points":"1 7.96 7.96 1 14.93 7.96","style":{"fill":"none","stroke":"#b2b2b2","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":1})]);
}

BackToTop.defaultProps = {"viewBox":"0 0 15.93 15.06"};

module.exports = BackToTop;

BackToTop.default = BackToTop;
